module.exports = __webpack_public_path__ + "static/media/1POLICY32.d556e3a5.jpg";